import {Form, message, Space} from "antd";
import React, {forwardRef, useImperativeHandle, useState} from "react";
import FetchUtil from "../../../utils/FetchUtil";
import FormUtil from "../../../utils/FormUtil";
import {DrawerForm, ProFormSwitch, ProFormText, ProFormTextArea} from "@ant-design/pro-components";
import MyRawData from "../../../components/MyRawData";


const CrawlerEditor = (props : any, ref: any) => {

    const [formRef] = Form.useForm();
    const [loading, setLoading] = useState(false);
    const [openForm, setOpenForm] = useState(false);

    const [info, setInfo] = useState<any | undefined>({});


    let isChanged = false;

    useImperativeHandle(ref, () => {
        return {
            openEditor: (r: any) => openEditor(r)
        }
    });
    const openEditor = async (r: any) => {
        setOpenForm(true);
        setLoading(true);
        if (r.id && r.id !== 0) {
            const res = await FetchUtil.awaitFetch("/adminApi/job/detail", {id: r.id});
            if (res.code === 200) {
                r = {...r, ...res.data};
            }
        }
        setInfo(r);
        formRef.resetFields();
        formRef.setFieldsValue(r);
        isChanged = false;
        setLoading(false)
    }

    const closeEditor = () => {
        const doClose = (open: boolean) => {
            setOpenForm(open);
            setInfo({});
        }
        FormUtil.close(isChanged, doClose);
    }

    const submitForm = async (values: any) => {
        console.log(typeof values.argument);
        if (typeof values.argument !== 'string') {
            values.argument = JSON.stringify(values.argument);
        }
        if (typeof values.headers !== 'string') {
            values.headers = JSON.stringify(values.headers);
        }
        if (typeof values.cookies !== 'string') {
            values.cookies = JSON.stringify(values.cookies);
        }
        values.status = values.status ? 1 : 0;
        const res = await FetchUtil.awaitFetch('/adminApi/job/edit', values);
        if (res.code === 200) {
            isChanged = false;
            closeEditor();
            message.success("保存成功！")
            if (props.callback) {
                props.callback();
            }
        }
    }

    return (
        <DrawerForm width={800}
                    form={formRef}
                    open={openForm}
                    colon={false}
                    labelCol={{span: 4, offset: 0}}
                    title={"内容编辑"}
                    layout="horizontal"
                    grid={true}
                    drawerProps={{onClose: closeEditor, forceRender: true, loading: loading}}
                    onFinish={submitForm}
                    onChange={() => isChanged = true}
        >
            <ProFormText name={"id"} hidden/>
            <ProFormText label={"任务名称"} name="name"/>
            <ProFormText label='执行服务器' name='serverId'/>
            <ProFormText label='来源' name='source'/>
            <ProFormText label='日志' name='logType'/>
            <ProFormText label='计划' name='schedule'/>
            <ProFormSwitch label={'状态'} name="status"/>
            <ProFormTextArea label='执行命令行' name='command'/>

            <Space direction="vertical" size={16} style={{paddingLeft: 64, paddingRight: 0, width: "100%"}}>
                <MyRawData rawData={info?.argument} label="执行参数" name="argument" editable={true} formRef={formRef}/>
                <MyRawData rawData={info?.headers} label="浏览器头" name="headers" editable={true} formRef={formRef}/>
                <MyRawData rawData={info?.cookies} label="请求Cookies" name="cookies" editable={true} formRef={formRef}/>
            </Space>
            {/*<ProFormTextArea label='执行参数' name='argument'/>*/}
            {/*<ProFormTextArea label='浏览器头' name='headers'/>*/}
            {/*<ProFormTextArea label='请求Cookies' name='cookies'/>*/}
        </DrawerForm>
    )
}
export default forwardRef(CrawlerEditor);
